import { gql } from "@apollo/client";

export const getSavedViewsQuery = gql`
    query SavedViews($savedViewsQueryInput: SavedViewsQueryInput!) {
        getAllSavedViewsForPage(savedViewsQueryInput: $savedViewsQueryInput) {
            items {
                id
                isDefault
                name
                page
                pageQuery
            }
        }
    }
`;
